export default __webpack_public_path__ + "static/media/referral-error-noti.a04490f3.svg";